import type { CardLabel } from '@molt/shared';
import { labelChipName, type LabelChipTranslate } from '@/components/LabelChip';

export function frontLabels(labels: readonly CardLabel[]): CardLabel[] {
  return labels.filter((label) => label.colour !== 'colourless');
}

export function labelDisplayName(
  label: Pick<CardLabel, 'name' | 'colour'>,
  t?: LabelChipTranslate,
): string {
  return labelChipName(label.colour, label.name, t);
}
